angular.module('controllers').controller('addressController', ['$scope', '$rootScope', '$controller', 'Crud', '$mdDialog', '$filter', '$http', '$route', '$routeParams', '$location', '$timeout', '$interval',
	function ($scope, $rootScope, $controller, Crud, $mdDialog, $filter, $http, $route, $routeParams, $location, $timeout, $interval) {
		$rootScope.path = '/address';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'address';
		$scope.pathTemplate = 'distribution/address';
		$scope.title = 'Coordonate strazi';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'street_no';
		$scope.defaultItem = 10;
		$rootScope.typeId = 'id';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'locality_name':{'label':'Localitate', 'filter':1, 'filterType':'input'},
			'section_name':{'label':'Cartier', 'filter':1, 'filterType':'input'},
			'street_name':{'label':'Strada', 'filter':1, 'filterType':'input'},
			'address_no':{'label':'Nr.', 'filter':1, 'filterType':'input'},
			'address_block':{'label':'Bloc', 'filter':1, 'filterType':'input'},
			'address_section':{'label':'Scara', 'filter':1, 'filterType':'input'},
            'address_level':{'label':'Et.', 'filter':1, 'filterType':'input'},
			'address_flat':{'label':'Ap.', 'filter':1, 'filterType':'input'},
			'address_type':{'label':'Tip', 'filter':1, 'filterType':'select'},
			//'address_latitude':{'label':'Latitudine', 'filter':1, 'filterType':'input'},
			//'address_longitude':{'label':'Longitudine', 'filter':1, 'filterType':'input'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};

		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];

		$scope.columns.address_type.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'Casa'},
			{'id':2, 'value' : 'Bloc'},
			{'id':3, 'value' : 'Birou'}
		];

		$scope.search.order = 'asc';
		$scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['columnDisplay'] = 'street_name';
        $scope.additionals['columnDisplay'] = 'address_no';
		$scope.additionals['jsonPath'] = '/json';
		$scope.additionals['address_type'] = $scope.columns.address_type.options;

		$scope.additionals['getCounties'] = function () {
			Crud.get($scope.additionals['jsonPath'] + '/counties.json')
				.success(function (data) {
					$scope.additionals['counties'] = data;
				});
		}
		$scope.additionals['getCounties']();

        /* autocomplete */
        function createFilterForLocality(query) {
            var capitalizeQuery = $scope.formatText(query);
            return function filterFn(item) {
                return item.locality_name.indexOf(capitalizeQuery) >= 0;
            };
        }
        function createFilterForSection(query) {
            var capitalizeQuery = $scope.formatText(query);
            return function filterFn(item) {
                return item.section_name.indexOf(capitalizeQuery) >= 0;
            };
        }
        function createFilterForStreet(query) {
            var capitalizeQuery = $scope.formatText(query);
            return function filterFn(item) {
                return item.street_name.indexOf(capitalizeQuery) >= 0;
            };
        }
        $scope.additionals['getLocalities'] = function(model, index) {
            model.locality_id = 0;
            Crud.get($scope.path + '/getLocalities?county_name='+model.county_name)
                .success(function (dataLoc) {

                    if(dataLoc.localities.length <= 0) {

                        Crud.get($scope.additionals['jsonPath'] + '/localities.json')
                            .success(function (data) {

                                if (angular.isUndefined(model.county_name)) {
                                    $scope.additionals['getLocalities']({"county_name": "Cluj"});
                                } else {
                                    if (!angular.isUndefined(index)) {
                                        $scope.additionals['localities' + index] = data[model.county_name];
                                    } else {
                                        $scope.additionals['localities'] = data[model.county_name];
                                    }
                                }
                                /* autocomplete */
                                function querySearch(query) {
                                    if (!angular.isUndefined(index)) {
                                        var results = query ? $scope.additionals['localities' + index].filter(createFilterForLocality(query)) : [];
                                    } else {
                                        if (!angular.isUndefined($scope.additionals['localities'])) {
                                            var results = query ? $scope.additionals['localities'].filter(createFilterForLocality(query)) : [];
                                        }
                                    }
                                    return results;
                                }
                                $scope.additionals['searchLocality'] = querySearch;
                                $scope.additionals['errors'] = {};
                                /* end autocomplete */

                            });
                    } else {

                        if (angular.isUndefined(model.county_name)) {
                            $scope.additionals['getLocalities']({"county_name": "Cluj"});
                        } else {
                            if (!angular.isUndefined(index)) {
                                $scope.additionals['localities' + index] = dataLoc['localities'];
                            } else {
                                $scope.additionals['localities'] = dataLoc['localities'];
                            }
                        }
                        /* autocomplete */
                        function querySearch(query) {
                            if (!angular.isUndefined(index)) {
                                var results = query ? $scope.additionals['localities' + index].filter(createFilterForLocality(query)) : [];
                            } else {
                                if (!angular.isUndefined($scope.additionals['localities'])) {
                                    var results = query ? $scope.additionals['localities'].filter(createFilterForLocality(query)) : [];
                                }
                            }
                            return results;
                        }
                        $scope.additionals['searchLocality'] = querySearch;
                        $scope.additionals['errors'] = {};
                        /* end autocomplete */
                    }

                });
        }
        $scope.additionals['getSections'] = function(model, index) {
            Crud.get($scope.path + '/getSections?county_name='+model.county_name+'&locality_name='+model.locality_name)
                .success(function (data) {
                    if (!angular.isUndefined(index)) {
                        $scope.additionals['sections' + index] = data['sections'];
                    } else {
                        $scope.additionals['sections'] = data['sections'];
                    }
                    /* autocomplete */
                    function querySearch(query) {
                        if (!angular.isUndefined(index)) {
                            var results = query ? $scope.additionals['sections' + index].filter(createFilterForSection(query)) : [];
                        } else {
                            if (!angular.isUndefined($scope.additionals['sections'])) {
                                var results = query ? $scope.additionals['sections'].filter(createFilterForSection(query)) : [];
                            }
                        }
                        return results;
                    }
                    $scope.additionals['searchSection'] = querySearch;
                    $scope.additionals['errors'] = {};
                    /* end autocomplete */
                });
        }
		$scope.additionals['getStreets'] = function(model, index) {

            if(model.locality_name != '') {
                if (!angular.isUndefined($scope.additionals['sections']) && $scope.additionals['sections'].length > 0) {

                    if (model.section_name != '') {
                        var pathStreet = $scope.path + '/getStreets?county_name=' + model.county_name + '&locality_name=' + model.locality_name+ '&section_name=' + model.section_name;
                    } else {

                        var pathStreet = '';
                        $scope.additionals['streets'] = [];
                        $scope.additionals['searchStreet'] = function querySearch(query) {return '';};
                    }
                } else {
                    var pathStreet = $scope.path + '/getStreets?county_name=' + model.county_name + '&locality_name=' + model.locality_name;
                }
                if (pathStreet != '') {
                    Crud.get(pathStreet)
                        .success(function (data) {
                            if (!angular.isUndefined(index)) {
                                $scope.additionals['streets' + index] = data.streets;
                            } else {
                                $scope.additionals['streets'] = data.streets;
                            }

                            /*autocomplete*/
                            function querySearch(query) {
                                if (!angular.isUndefined(index)) {
                                    var results = query ? $scope.additionals['streets' + index].filter(createFilterForStreet(query)) : [];
                                } else {
                                    if (!angular.isUndefined($scope.additionals['streets'])) {
                                        var results = query ? $scope.additionals['streets'].filter(createFilterForStreet(query)) : [];
                                    }
                                }
                                return results;
                            }

                            $scope.additionals['searchStreet'] = querySearch;
                            $scope.additionals['errors'] = {};
                            /*end autocomplete*/
                        });
                    }

                }
		}
        /* end autocomplete */

		if (angular.isUndefined($scope.search.county_name)) {
			$scope.search.county_name = 'Cluj';
		}

		$scope.additionals['function']= function(ev, model) {
			$scope.additionals['selectedItemStreet'] = '';
			$scope.additionals['selectedItemLocality'] = '';
            $scope.additionals['selectedItemSection'] = '';

            $scope.additionals['selectedItemClientMultiple'] = '';
            $scope.additionals['selectedItemStreeMultiple'] = '';
            $scope.additionals['selectedItemSectionMultiple'] = '';

			if (angular.isUndefined(model.county_name)) {
				$scope.additionals['getLocalities']({"county_name":"Cluj"});
			}
			if($scope.action == 'store') {
				if (angular.isUndefined(model.county_name)) {
					model.county_name = 'Cluj';
				}
			}
			if($scope.action == 'update') {
				$scope.additionals['getLocalities'](model);
				$scope.additionals['getStreets'](model);
                $scope.additionals['getSections'](model);
			}
			if($scope.action == 'updatemultiple') {
				$scope.additionals['selectedItemLocalityMultiple'] = [];
				$scope.additionals['selectedItemStreet'] = [];
                $scope.additionals['selectedItemSection'] = [];
				angular.forEach(model, function (item, index) {
					$scope.additionals['getLocalities'](item, index);
					$scope.additionals['getStreets'](item, index);
                    $scope.additionals['getSections'](item, index);
				});
			}
		}

        $scope.additionals['internFunction'] = function(ev, model) {
            if($scope.action == 'updatemultiple') {
                angular.forEach(model, function (item, index) {
                    if(index != 'route') {
                        if (!angular.isUndefined($scope.additionals['localities'+index])) {
                            if (!angular.isUndefined($scope.additionals['localities' + index][0]['id'])) {
                                var checkLocalityId = $scope.additionals['checkField']($scope.additionals['localities' + index], 'id', 'locality_name', item['locality_name']);
                                if (checkLocalityId) {
                                    item.locality_id = checkLocalityId;
                                } else {
                                    item.locality_id = 0;
                                }
                            } else {
                                item.locality_id = 'js';
                            }
                        }
                        var checkLocalityName = $scope.additionals['checkField']($scope.additionals['localities'+index], 'locality_name', 'locality_name', item['locality_name']);
                        if (checkLocalityName) {
                            item.locality_name = checkLocalityName;
                        } else {
                            if(item.locality_id == 'js') {
                                item.locality_name = '';
                            }
                        }
                        if (!angular.isUndefined($scope.additionals['sections'+index])) {
                            var checkSectionId = $scope.additionals['checkField']($scope.additionals['sections' + index], 'id', 'section_name', item['section_name']);
                            if (checkSectionId) {
                                item.section_id = checkSectionId;
                            } else {
                                item.section_id = 0;
                            }
                        }
                        var checkSectionName = $scope.additionals['checkField']($scope.additionals['sections'+index], 'section_name', 'section_name', item['section_name']);
                        if (checkSectionName) {
                            item.section_name = checkSectionName;
                        }
                        if (!angular.isUndefined($scope.additionals['streets'+index])) {
                            var checkStreetId = $scope.additionals['checkField']($scope.additionals['streets' + index], 'id', 'street_name', item['street_name']);
                            if (checkStreetId) {
                                item.street_id = checkStreetId;
                            } else {
                                item.street_id = 0;
                            }
                        }
                        var checkStreetName = $scope.additionals['checkField']($scope.additionals['streets'+index], 'street_name', 'street_name', item['street_name']);
                        if (checkStreetName) {
                            item.street_name = checkStreetName;
                        }



                    }
                });
            } else {
                if (model['locality_name'] != '' && $scope.additionals['localities']) {
                    if (!angular.isUndefined($scope.additionals['localities'][0]['id'])) {
                        var checkLocalityId = $scope.additionals['checkField']($scope.additionals['localities'], 'id', 'locality_name', model['locality_name']);
                        if (checkLocalityId) {
                            model.locality_id = checkLocalityId;
                        } else {
                            model.locality_id = 0;
                        }
                    } else {
                        model.locality_id = 'js';
                    }

                    var checkLocalityName = $scope.additionals['checkField']($scope.additionals['localities'], 'locality_name', 'locality_name', model['locality_name']);
                    if (checkLocalityName) {
                        model.locality_name = checkLocalityName;
                    } else {
                        if(model.locality_id == 'js') {
                            model.locality_name = '';
                        }
                    }
                }
                if (model['section_name'] != '' && $scope.additionals['sections']) {
                    var checkSectionId = $scope.additionals['checkField']($scope.additionals['sections'], 'id', 'section_name', model['section_name']);
                    if (checkSectionId) {
                        model.section_id = checkSectionId;
                    } else {
                        model.section_id = 0;
                    }
                    var checkSectionName = $scope.additionals['checkField']($scope.additionals['sections'], 'section_name', 'section_name', model['section_name']);
                    if (checkSectionName) {
                        model.section_name = checkSectionName;
                    }
                }
                if (model['street_name'] != '' && $scope.additionals['streets']) {
                    var checkStreetId = $scope.additionals['checkField']($scope.additionals['streets'], 'id', 'street_name', model['street_name']);
                    if (checkStreetId) {
                        model.street_id = checkStreetId;
                    } else {
                        model.street_id = 0;
                    }
                    var checkStreetName = $scope.additionals['checkField']($scope.additionals['streets'], 'street_name', 'street_name', model['street_name']);
                    if (checkStreetName) {
                        model.street_name = checkStreetName;
                    }
                }
            }
        }

        $scope.additionals['functionResult']= function(ev, data) {
            if($scope.action == 'update' || $scope.action == 'store') {
                if (!angular.isUndefined($scope.modelData.street_name)) {
                    $scope.modelData.street_name = $scope.additionals['formatTextResult']($scope.modelData.street_name);
                }
                if (!angular.isUndefined($scope.modelData.locality_name)) {
                    $scope.modelData.locality_name = $scope.additionals['formatTextResult']($scope.modelData.locality_name);
                }
                if (!angular.isUndefined($scope.modelData.section_name)) {
                    if ($scope.modelData.section_name != null) {
                        $scope.modelData.section_name = $scope.additionals['formatTextResult']($scope.modelData.section_name);
                    }
                }
                if (!angular.isUndefined($scope.modelData.street_name)) {
                    $scope.modelData.street_name = $scope.additionals['formatTextResult']($scope.modelData.street_name);
                }
            }
            if($scope.action == 'updatemultiple') {
                if (!angular.isUndefined($scope.modelsData)) {
                    angular.forEach($scope.modelsData, function (item, key) {
                        if (item.selected !== false) {
                            if (!angular.isUndefined($scope.modelsData[key].street_name)) {
                                $scope.modelsData[key].street_name = $scope.additionals['formatTextResult']($scope.modelsData[key].street_name);
                            }
                            if (!angular.isUndefined($scope.modelsData[key].section_name)) {
                                $scope.modelsData[key].section_name = $scope.additionals['formatTextResult']($scope.modelsData[key].section_name);
                            }
                            if (!angular.isUndefined($scope.modelsData[key].locality_name)) {
                                $scope.modelsData[key].locality_name = $scope.additionals['formatTextResult']($scope.modelsData[key].locality_name);
                            }
                            if (!angular.isUndefined($scope.modelsData[key].street_name)) {
                                $scope.modelsData[key].street_name = $scope.additionals['formatTextResult']($scope.modelsData[key].street_name);
                            }
                        }
                    });
                }

            }
        }

        /* change field */
        $scope.additionals['changeField']= function(model, prop, key) {
            if(prop == 'locality') {
                if (!angular.isUndefined(key)) {
                    model[key].locality_new = false;
                } else {
                    model.locality_new = false;
                }
            }
            if(prop == 'section') {
                if (!angular.isUndefined(key)) {
                    model[key].section_new = false;
                } else {
                    model.section_new = false;
                }
            }
            if(prop == 'street') {
                if (!angular.isUndefined(key)) {
                    model[key].street_new = false;
                } else {
                    model.street_new = false;
                }
            }
        }

        /* close field */
        $scope.additionals['closeField'] = function (paramName, model, key) {

            if (!angular.isUndefined(key)) {
                model[key][paramName] = '';

                if (paramName == 'county_name') {
                    $scope.additionals['removeFields']('county', model, key);
                }
                if (paramName == 'locality_name') {
                    $scope.additionals['removeFields']('locality', model, key);
                }
                if (paramName == 'section_name') {
                    $scope.additionals['removeFields']('section', model, key);
                }
                if (paramName == 'street_name') {
                    $scope.additionals['removeFields']('street', model, key);
                }
            } else {
                model[paramName] = '';

                if (paramName == 'county_name') {
                    $scope.additionals['removeFields']('county', model);
                }
                if (paramName == 'locality_name') {
                    $scope.additionals['removeFields']('locality', model);
                }
                if (paramName == 'section_name') {
                    $scope.additionals['removeFields']('section', model);
                }
                if (paramName == 'street_name') {
                    $scope.additionals['removeFields']('street', model);
                }
            }

        }

        /* remove field */
        $scope.additionals['removeFields'] = function (field, modelData, key) {
            if (!angular.isUndefined(key)) {
                switch (field) {
                    case 'county':
                        modelData[key].locality_name='';
                        modelData[key].section_name = '';
                        modelData[key].street_name = '';
                        modelData[key].address_no = '';
                        modelData[key].address_section = '';
                        modelData[key].address_block = '';
                        modelData[key].address_level = '';
                        modelData[key].address_flat = '';
                        modelData[key].address_type = '';
                        break;

                    case 'locality':
                        modelData[key].section_name = '';
                        modelData[key].street_name = '';
                        modelData[key].address_no = '';
                        modelData[key].address_section = '';
                        modelData[key].address_block = '';
                        modelData[key].address_level = '';
                        modelData[key].address_flat = '';
                        modelData[key].address_type = '';
                        break;

                    case 'section':
                        modelData[key].street_name = '';
                        modelData[key].address_no = '';
                        modelData[key].address_section = '';
                        modelData[key].address_block = '';
                        modelData[key].address_level = '';
                        modelData[key].address_flat = '';
                        modelData[key].address_type = '';
                        break;

                    case 'street':
                        modelData[key].address_no = '';
                        modelData[key].address_section = '';
                        modelData[key].address_block = '';
                        modelData[key].address_level = '';
                        modelData[key].address_flat = '';
                        modelData[key].address_type = '';
                        break;
                }
            } else {
                switch (field) {
                    case 'county':
                        modelData.locality_name = '';
                        modelData.section_name = '';
                        modelData.street_name = '';
                        modelData.address_no = '';
                        modelData.address_section = '';
                        modelData.address_block = '';
                        modelData.address_level = '';
                        modelData.address_flat = '';
                        modelData.address_type = '';
                        break;

                    case 'locality':
                        modelData.section_name = '';
                        modelData.street_name = '';
                        modelData.address_no = '';
                        modelData.address_section = '';
                        modelData.address_block = '';
                        modelData.address_level = '';
                        modelData.address_flat = '';
                        modelData.address_type = '';
                        break;

                    case 'section':
                        modelData.street_name = '';
                        modelData.address_no = '';
                        modelData.address_section = '';
                        modelData.address_block = '';
                        modelData.address_level = '';
                        modelData.address_flat = '';
                        modelData.address_type = '';
                        break;

                    case 'street':
                        modelData.address_no = '';
                        modelData.address_section = '';
                        modelData.address_block = '';
                        modelData.address_level = '';
                        modelData.address_flat = '';
                        modelData.address_type = '';
                        break;
                }
            }
        }

    }]
);
